<template>
  <v-container class="adicionarConvidado mt-8">
    <v-layout
      align-center
      justify-center
    >
      <VerifyPhone
        v-if="isVerifying"
        phone="phone"
        @verifyCancel="onCancelVerify"
        @phoneVerified="onVerify()"
      />
      <v-flex
        xs10
        md8
        offset-xs1
        offset-md2
        justify-center
      >
        <v-form
          ref="vform"
          v-model="valid"
        >
          <v-card ref="form">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex
                  xs12
                >
                  <v-text-field
                    ref="name"
                    v-model="name"
                    :rules="[$rules.required()]"
                    label="Nome"
                    placeholder="Digite o nome"
                    required
                  />
                  <v-text-field
                    v-model="email"
                    label="E-mail"
                    :rules="[$rules.required(), $rules.email()]"
                    placeholder="Digite o email"
                    :disabled="isUpdating"
                  />
                  <v-text-field
                    v-model="phone"
                    v-mask="'(##) #####-####'"
                    label="Telefone"
                    placeholder="Digite o telefone"
                  />
                </v-flex>
                <template v-if="$route.name==='guestsUpdate'">
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      v-model="cpfCnpj"
                      label="CPF / CNPJ"
                      placeholder="Digite o CPF ou CNPJ"
                      required
                      :rules="[$rules.cpfCnpj()]"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md4
                  >
                    <v-text-field
                      v-model="phone"
                      label="Telefone"
                      placeholder="Digite o telefone"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md2
                  >
                    <v-checkbox
                      v-model="isWhats"
                      label="WhatsApp"
                      value="wpp"
                    />
                  </v-flex>
                </template>
                <v-flex
                  xs12
                  lg4
                >
                  <v-checkbox
                    :value="isAdmin"
                    label="Administrador"
                    required
                    @change="onAdminChange"
                  />
                </v-flex>
                <v-flex
                  xs12
                  lg8
                >
                  <v-select
                    :value="features"
                    :items="permissionsSelector"
                    :item-text="item => item.label"
                    :item-value="item => permissions.find(p => p.id === item.id)"
                    chips
                    single-line
                    small-chips
                    label="Permissões"
                    multiple
                    outlined
                    :rules="[$rules.minSelect(1)]"
                    @input="onFeaturesUpdate"
                  />
                </v-flex>

                <!-- <v-flex
                  xs12
                  lg4
                  class="float-right-inner"
                >
                  <v-switch
                    v-model="active"
                    inset
                    label="Ativo"
                  />
                </v-flex> -->
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="$router.push({name: 'GuestsList'})"
              >
                Cancelar
              </v-btn>
              <v-btn
                v-if="isUpdating"
                color="primary"
                rounded
                large
                :disabled="!valid"
                @click="onContinue()"
              >
                Atualizar
              </v-btn>
              <v-btn
                v-else
                color="primary"
                rounded
                large
                :disabled="!valid"
                @click="onContinue()"
              >
                Enviar Convite
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
      <v-flex
        xs1
        md2
      />
    </v-layout>

    <!-- Dialogs -->
    <v-dialog
      :value="isResetDialogOpen"
      max-width="390"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Usuário já cadastrado
        </v-card-title>
        <v-card-text>
          Usuario ja vinculado na conta e produto.
          Deseja re-enviar uma senha para este usuário?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="setResetDialogCallback(null)">
            Não
          </v-btn>
          <v-btn
            color="primary"
            rounded
            large
            @click="() => resetDialogCallback && resetDialogCallback.call()"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
      AGUARDE...
    </v-overlay>
  </v-container>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { mask } from 'vue-the-mask';
import VerifyPhone from '@/views/VerifyPhone';

const session = createNamespacedHelpers('session');
const guestsList = createNamespacedHelpers('views/guestsList');

const data = () => ({
  name: '',
  email: '',
  cpfCnpj: '',
  isWhats: false,
  phone: '',
  isAdmin: false,
  isVerifying: false,
  valid: false,
  features: [],
  currentAccount: null,
  currentPhone: '',
});

export default {
  name: 'GuestsAdd',
  directives: { mask },
  components: {
    VerifyPhone,
  },
  props: {
    id: {
      type: [Number, String],
      default: '',
    },
    user: {
      type: Object,
    }
  },
  data,
  computed: {
    ...session.mapGetters([
      'accounts',
    ]),
    ...guestsList.mapGetters([
      'permissionsSelector',
      'isResetDialogOpen',
    ]),
    ...guestsList.mapState([
      'updatingGuest',
      'resetDialogCallback',
      'permissions',
      'overlay',
    ]),
    isUpdating() {
      return this.$route.name === 'GuestsUpdate';
    },
    toolbarTitle() {
      return this.isUpdating ? 'Atualizar usuário' : 'Adicionar usuário';
    },
  },
  methods: {
    ...guestsList.mapMutations([
      'setResetDialogCallback',
      'setOverlay',
    ]),
    ...guestsList.mapActions([
      'loadPermissions',
      'loadGuest',
      'getGuestFeatures',
      'onAddClick',
      'onUpdateClick',
      'onOverlay',
    ]),
    onCancelVerify() {
      this.isVerifying = false;
    },
    onContinue() {
      if (this.phone.replace(/\D/g, '') !== '' && this.phone.replace(/\D/g, '') !== this.currentPhone) {
        this.isVerifying = true;
      } else this.onCreate();
    },
    async onVerify() {
      this.isVerifying = false;
      this.onCreate();
    },
    onCreate() {
      if (this.isUpdating === true) {
        this.onUpdateClick({
          user: {
            id: Number(this.id),
            email: this.email,
            name: this.name,
            isAdmin: this.isAdmin,
            cpfCnpj: this.cpfCnpj,
            phone: `${this.phone.replace(/\D/g, '')}`,
            isWhats: this.isWhats,
          },
          features: this.features,
          onSuccess: this.onSuccess,
        });
      } else {
        this.onAddClick({
          user: {
            email: this.email,
            name: this.name,
            isAdmin: this.isAdmin,
            phone: `${this.phone.replace(/\D/g, '')}`,
          },
          features: this.features,
          onSuccess: this.onSuccess,
        });
      }
    },
    onOverlay() {
      this.setOverlay(true);
    },
    onSuccess() {
      this.$router.push({ name: 'GuestsList' });
    },
    onAdminChange(isAdmin) {
      this.setAdmin(isAdmin);
      if (this.isAdmin) {
        this.setAllFeatures();
      }
    },
    onFeaturesUpdate(newFeatures) {
      if (newFeatures.length < this.features.length) {
        this.setAdmin(false);
      }

      this.features = newFeatures;
    },
    setAdmin(isAdmin) {
      this.isAdmin = isAdmin;
    },
    setAllFeatures() {
      this.features = [...this.permissions];
    },
    setFeatures(id) {
      this.getGuestFeatures({ id }).then((featureData) => {
        this.features = featureData;
      }).catch(() => {
        this.features = [];
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (vm.isUpdating) {
          const {
            id, name, email, cpfCnpj,
            phone, isAdmin, whatsPhone,
          } = vm.user;
          vm.name = name;
          vm.email = email;
          vm.cpfCnpj = cpfCnpj;
          vm.phone = phone;
          vm.currentPhone = phone;
          vm.isAdmin = isAdmin;
          vm.isWhats = !!whatsPhone;
          vm.setFeatures(id);
      } else {
        Object.assign(vm.$data, data());
        vm.$refs.vform.resetValidation();
      }
      vm.loadPermissions();
    });
  },
};
</script>
<style lang="stylus" scoped>
  .adicionarConvidado /deep/ {
  // FIXME: Move these css to specific classes to not mess with children components
  .flex.xs10.justify-center {
    text-align: center;
  }
  .float-right-inner > div {
      float:  right;
  }
  button.v-btn.v-btn--depressed.v-btn--flat.v-btn--outlined.theme--light.v-size--default {
      margin-top: 15px;
  }
  button.v-btn.v-btn--flat.v-btn--text.theme--light.v-size--default {
      margin-right: 15px;
  }
}
</style>
